<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="80px">
        <el-row :gutter="20">
           <el-col :span="6">
            <el-form-item label="所属分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="queryLinkageByBrandTypeKey()"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="质检备注项目">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryEvaluateProjectArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-button type="primary" @click="getSelectOptionList"
              >查询</el-button
            >
            <el-button type="primary" @click="addSelectOption">创建</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="选项名称"> </el-table-column>
        <el-table-column prop="brandName" label="质检备注项目"> </el-table-column>
        <el-table-column prop="categoryName" label="所属分类">
        </el-table-column>
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="editSelectOption(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑选项' : '新建选项'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editOptionForm"
            :model="editOptionForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editOptionForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="选项名称" prop="name">
              <el-input clearable v-model="editOptionForm.name"></el-input>
            </el-form-item>
            <el-form-item label="所属分类" prop="categoryId">
              <el-select
                v-model="editOptionForm.categoryId"
                clearable
                placeholder="请选择"
                @change="eidtLinkageByBrandTypeKey()"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="质检项目" prop="parentId">
              <el-select v-model="editOptionForm.parentId" placeholder="请选择">
                <el-option
                  v-for="item in evaluateProjectArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      evaluateTypeArray: this.global.evaluateType,
      queryEvaluateProjectArray: [],
      evaluateProjectArray: [],
      isGoodOptions: this.global.isGoodOptions,
      // 查询数据
      queryParamForm: {
        brandTypeKey: "",
        brandId: "",
        categoryId:null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: "quality_remark_item_value",
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editOptionForm: {
        id: null,
        value: null,
        name: null,
        brandTypeKey: "",
        parentId: null,
        isGood: 0,
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入选项名称", trigger: "change" },
        ],
        categoryId: [
          { required: true, message: "请选择所属分类", trigger: "change" },
        ],
        parentId: [
          { required: true, message: "请选择质检备注项目", trigger: "change" },
        ],
        
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      fullscreenLoading:false
    };
  },
  watch: {},
  computed: {},
  methods: {
     deleteLinkage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteLinkage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getSelectOptionList()
          }
      })
      })
     
    },
    
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getSelectOptionList();
    },
    getCategory() {
      let self = this;
      self.$api
        .getClass({
          typeKey: "category",
          page: 1,
          status:1,
          size: 100000,
        })
        .then((res) => {
          self.categoryOptions = res.data.records || [];
        });
    },
    // 获取表格数据
    getSelectOptionList() {
      let self = this;
      self.$api
        .getClass({
          brandTypeKey: self.queryParamForm.brandTypeKey,
          brandId: self.queryParamForm.brandId,
          categoryId:self.queryParamForm.categoryId,
          typeKey: self.typeKey,
          page: self.currentPage,
          size: self.pageSize,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addSelectOption() {
      this.dlgType = "new";
      this.editOptionForm = {};
      this.$nextTick(()=>{
          this.$refs['editOptionForm'].clearValidate()
      })
      this.eidtLinkageByBrandTypeKey();
      this.editOptionForm.parentId = null;
      this.isDlg = true;
    },

    // 修改
    editSelectOption(row) {
      let self = this;
      self.editOptionForm = {};
      self.dlgType = "change";

      self.editOptionForm = row;
      this.eidtLinkageByBrandTypeKey();
      this.editOptionForm.parentId = row.brandId;
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editOptionForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editOptionForm) {
            params[i] = this.editOptionForm[i];
          }
          params.typeKey = self.typeKey;
          if (self.dlgType === "change") {
            self.$api.changeLinkage(params.id, params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getSelectOptionList();
                self.closeEditormodelDlg();
              }
            });
          } else {
            self.$api.addLinkage(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                self.getSelectOptionList();
                self.closeEditormodelDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      self.$api
        .changeLinkage(row.id, {
          name: row.name,
          status: newStatus,
          typeKey: self.typeKey,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            self.getSelectOptionList();
          }
        });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .changeLinkageOrder({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getSelectOptionList();
          }
        });
    },
    //查询时，评估项目集合
    queryLinkageByBrandTypeKey() {
      let self = this;
      console.log("queryLinkageByBrandTypeKey");
      self.queryParamForm.brandId = null;
      if (
        self.queryParamForm.categoryId === null ||
        self.queryParamForm.categoryId === "" 
      ) {
        self.queryEvaluateProjectArray = [];
      } else {
        this.$api
          .getTemplateValue({
            categoryId:self.queryParamForm.categoryId,
            //typeKey: self.queryParamForm.brandTypeKey+ ",category",
            typeKey: "quality_remark_item,category",
          })
          .then((data) => {
            self.queryEvaluateProjectArray = data.data;
          });
      }
    },

    //更新时，评估项目集合
    eidtLinkageByBrandTypeKey() {
      let self = this;
      this.$set(this.editOptionForm, "parentId", null);
      if (
        self.editOptionForm.categoryId === "" ||
        self.editOptionForm.brandTypeKey === ""
      ) {
        self.evaluateProjectArray = [];
      } else {
        self.$api
          .getTemplateValue({
            categoryId: self.editOptionForm.categoryId,
            //typeKey: self.editOptionForm.brandTypeKey + ",category",
            typeKey: "quality_remark_item,category",
          })
          .then((data) => {
            self.evaluateProjectArray = data.data;
          });
      }
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getSelectOptionList();
    self.getCategory();
  },
};
</script>
<style lang="less" scoped></style>
